import React from 'react';
import RootRenderer from './dynamic-components/RootRenderer';
import FieldPanelRenderer from './dynamic-components/FieldPanelRenderer';
import KeyValueTableRenderer from './dynamic-components/KeyValueTableRenderer';
import FilesListRenderer from './dynamic-components/FilesListRenderer';
import ImageRenderer from './dynamic-components/ImageRenderer';

interface Props {
  schema: any;
}

const typenameToComponentsMap = new Map<string, React.FC<any>>([
  ['root', RootRenderer],
  ['fieldPanel', FieldPanelRenderer],
  ['keyValueTable', KeyValueTableRenderer],
  ['filesList', FilesListRenderer],
  ['image', ImageRenderer],
]);

const DynamicContentRenderer: React.FC<Props> = ({ schema }) => {
  if (Array.isArray(schema)) {
    return schema.map((el, i) => <DynamicContentRenderer key={i} schema={el} />);
  }

  const typename = schema.__typename;
  if (!typename) {
    throw new Error(`Schema doesn't have __typename: "${JSON.stringify(schema)}"`);
  }

  const component = typenameToComponentsMap.get(typename);
  if (!component) {
    throw new Error(`Component for __typename "${typename}" doesn't exist.`);
  }

  return React.createElement(component, schema);
};

export default React.memo(DynamicContentRenderer);
